/* ============
 * Site Languages Module Mutations
 * ============
 */

import { FETCH_SITELANGUAGES } from './../../mutation-types';

export default {
  [FETCH_SITELANGUAGES](state, { siteLanguagesData }) {
    state.all = siteLanguagesData;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/siteLanguages/mutations.js